export enum SalaryZone {
  PKS = "PKS",
}

export const DEFAULT_SALARY_ZONE = "Muu Suomi";

export const getZoneLabel = (zone?: string) => {
  if (!zone) return DEFAULT_SALARY_ZONE;
  if (zone === SalaryZone.PKS) return SalaryZone.PKS;
  return zone;
};
